<mat-sidenav
  class="mat-elevation-z3"
  mode="side"
  [autoFocus]="false"
  [(opened)]="opened"
>
  <div class="app-sidenav-content">
    <div
      #content
      class="app-content"
      [ngClass]="{ toolActivated: toolbox.activeTool$ | async }"
    >
      @if (toolbox.activeTool$ | async) {
        <igo-home-button (unselectButton)="onUnselectButtonClick()" />
      }

      <igo-panel [title]="title$ | async | translate">
        @if (toolbox.activeTool$ | async) {
          <button
            mat-icon-button
            panelLeftButton
            tooltip-position="below"
            matTooltipShowDelay="500"
            [matTooltip]="'igo.context.sidenav.goBack' | translate"
            (click)="onPreviousButtonClick()"
          >
            <mat-icon>arrow_back</mat-icon>
          </button>
        }
        <div class="toolbox-container">
          <igo-toolbox
            class="igo-toolbox"
            color="primary"
            [animate]="true"
            [toolbox]="toolbox"
          />
          @if (langBtnEnabled && (toolbox.activeTool$ | async) === undefined) {
            <div class="lang-btn">
              <button matButton class="btn-link" (click)="toggleLanguage()">
                {{ getSwitchLabel() | translate }}
              </button>
            </div>
          }
        </div>
      </igo-panel>
    </div>
  </div>
  <igo-resizable-bar
    anchor="right"
    min="360"
    max="800"
    (change)="handleChange($event)"
  />
</mat-sidenav>
